import { useState, useEffect } from "react";
import { encuestaApi, encuestaRealizada } from "../api";
import uuid from "react-uuid";
import "./Encuesta.css";

type ModalProps = {
    isOpen: boolean;
    children: React.ReactNode;
};

const Modal = ({ isOpen, children }: ModalProps) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal">{children}</div>
        </div>
    );
};



const Encuesta = () => {

    
    const [modalOpen, setModalOpen] = useState(false);
    const [recomendacion, setRecomendacion] = useState(null);
    const [bienestar, setBienestar] = useState(null);
    const [equilibrioLaboral, setEquilibrioLaboral] = useState(null);
    const [cantidadTrabajo, setCantidadTrabajo] = useState(null);
    const [herramientasRecursos, setHerramientasRecursos] = useState(null);
    const [respuestas, setRespuestas] = useState<{
        Recomendacion: string | null;
        Bienestar: string | null;
        EquilibrioLaboral: string | null;
        CantidadTrabajo: string | null;
        HerramientasRecursos: string | null;
    }>({
        Recomendacion: null,
        Bienestar: null,
        EquilibrioLaboral: null,
        CantidadTrabajo: null,
        HerramientasRecursos: null
    });
    const [encuestaEnviada, setEncuestaEnviada] = useState(true);
    const preguntas: Record<string, string> = {
        Recomendacion: "¿Recomendarías a un amigo trabajar en Haceb?",
        Bienestar: "HACEB brinda a sus empleados actividades y programas...",
        EquilibrioLaboral: "Puedo mantener un equilibrio razonable entre la vida laboral y familiar",
        CantidadTrabajo: "La cantidad de trabajo que se espera de mí es razonable",
        HerramientasRecursos: "Considero que cuento con las herramientas y los recursos adecuados..."
    };

    const userDataString = sessionStorage.getItem("userData");
    const userData = JSON.parse(userDataString ?? "{}");

    useEffect(() => {
        const verificarEncuesta = async () => {
            try {
                const cedula = userData?.Cédula ?? "";
                const encuestaRealizadaUsuario = await encuestaRealizada(cedula);
                setEncuestaEnviada(encuestaRealizadaUsuario[0]);
            } catch (error) {
                console.error("Error al verificar encuesta realizada:", error);
            }
        };

        // verificarEncuesta();
    }, []);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleRespuesta = (pregunta: any, respuesta: any) => {
        setRespuestas(prevRespuestas => ({
            ...prevRespuestas,
            [pregunta]: respuesta
        }));
    };

    const enviarRespuestas = async () => {
        const currentDate = new Date();
        // Crear un nuevo objeto para almacenar las preguntas y las respuestas
        const respuestasCompletas = {
            CEDULA: userData?.CEDULA ?? "",
            id: uuid(),
            fecha: currentDate,
            user: {
                CARGO: userData?.CARGO ?? "",
                DIRECCION: userData?.DIRECCION ?? "",
                DIRECCION_HIJA: userData?.DIRECCION_HIJA ?? "",
                NOM_CENTRO: userData?.NOM_CENTRO ?? "",
                FEC_NACI: userData?.FEC_NACI ?? ""
            },
            ...respuestas
        };
        for (const pregunta in preguntas) {
            if (preguntas.hasOwnProperty(pregunta)) {
                (respuestasCompletas as any)[pregunta] = {
                    pregunta: preguntas[pregunta as keyof typeof preguntas],
                    respuesta: respuestas[pregunta as keyof typeof respuestas] // Explicitly define the type of respuestas object
                };
            }
        }

        //console.log("Respuestas:", respuestasCompletas);

        try {
            // Llama a la función encuestaApi y pasa los datos de la encuesta
            const response = await encuestaApi(respuestasCompletas);

            // Verifica si la respuesta fue exitosa
            if (response.ok) {
                //console.log("Respuestas enviadas con éxito");
                setRespuestas({
                    Recomendacion: null,
                    Bienestar: null,
                    EquilibrioLaboral: null,
                    CantidadTrabajo: null,
                    HerramientasRecursos: null
                });
                toggleModal();
                setModalOpen(false);
                setEncuestaEnviada(true);
            } else {
                console.error("Hubo un problema al enviar las respuestas:", response.statusText);
            }
        } catch (error: any) {
            console.error("Hubo un problema al enviar las respuestas:", error.message);
        }
    };

    const handleRecomendacion = (value: any) => {
        if (value === recomendacion) {
            setRecomendacion(null);
        } else {
            setRecomendacion(value);
            handleRespuesta("Recomendacion", value);
        }
    };

    const handleBienestar = (value: any) => {
        if (value === bienestar) {
            setBienestar(null);
        } else {
            setBienestar(value);
            handleRespuesta("Bienestar", value);
        }
    };

    const handleEquilibrioLaboral = (value: any) => {
        if (value === equilibrioLaboral) {
            setEquilibrioLaboral(null);
        } else {
            setEquilibrioLaboral(value);
            handleRespuesta("EquilibrioLaboral", value);
        }
    };

    const handleCantidadTrabajo = (value: any) => {
        if (value === cantidadTrabajo) {
            setCantidadTrabajo(null);
        } else {
            setCantidadTrabajo(value);
            handleRespuesta("CantidadTrabajo", value);
        }
    };

    const handleHerramientasRecursos = (value: any) => {
        if (value === herramientasRecursos) {
            setHerramientasRecursos(null);
        } else {
            setHerramientasRecursos(value);
            handleRespuesta("HerramientasRecursos", value);
        }
    };

    return (
        <div>
            {/* {!encuestaEnviada && (
                <button onClick={toggleModal} className="commandButton3">
                    Encuesta Haceb
                </button>
            )} */}
            <Modal isOpen={modalOpen}>
                <div className="container-pregunta">
                    <div>
                        <h5 className="h5-titulo">¿Recomendarías a un amigo trabajar en Haceb?</h5>
                        <div>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                                <label key={num} style={{ display: "inline-block", marginRight: "10px" }}>
                                    <div className="carita-btn">{num}</div>
                                    <div>
                                        <input
                                            type="checkbox"
                                            className="c"
                                            value={num}
                                            onChange={() => handleRecomendacion(num)}
                                            checked={recomendacion === num}
                                        />
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h5 className="h5-titulo">
                            HACEB brinda a sus empleados actividades y programas que mejoren el bienestar y progreso del empleado y sus familias como: Estar
                            bien, Red de salud mental, Espacios de diversión, Bienestar financiero, Construyamos progreso, voluntariados, formaciones, entre
                            otros.
                        </h5>
                        <div>
                            {[
                                { emoji: "😔", valor: "Totalmente en desacuerdo" },
                                { emoji: "🙁", valor: "Estoy en desacuerdo" },
                                { emoji: "😐", valor: "Ni de acuerdo o en desacuerdo" },
                                { emoji: "🙂", valor: "Estoy de acuerdo" },
                                { emoji: "😃", valor: "Totalmente de acuerdo" }
                            ].map((respuesta, index) => (
                                <label key={index} style={{ display: "inline-block", marginRight: "10px" }}>
                                    <div className="carita-btn">{respuesta.emoji}</div>
                                    <div>
                                        <input
                                            type="checkbox"
                                            className="checkbox-btn"
                                            value={respuesta.valor}
                                            onChange={() => handleBienestar(respuesta.valor)}
                                            checked={bienestar === respuesta.valor}
                                        />
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h5 className="h5-titulo">Puedo mantener un equilibrio razonable entre la vida laboral y familiar</h5>
                        <div>
                            {[
                                { emoji: "😔", valor: "Totalmente en desacuerdo" },
                                { emoji: "🙁", valor: "Estoy en desacuerdo" },
                                { emoji: "😐", valor: "Ni de acuerdo o en desacuerdo" },
                                { emoji: "🙂", valor: "Estoy de acuerdo" },
                                { emoji: "😃", valor: "Totalmente de acuerdo" }
                            ].map((respuesta, index) => (
                                <label key={index} style={{ display: "inline-block", marginRight: "10px" }}>
                                    <div className="carita-btn">{respuesta.emoji}</div>
                                    <div>
                                        <input
                                            type="checkbox"
                                            className="checkbox-btn"
                                            value={respuesta.valor}
                                            onChange={() => handleEquilibrioLaboral(respuesta.valor)}
                                            checked={equilibrioLaboral === respuesta.valor}
                                        />
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h5 className="h5-titulo">La cantidad de trabajo que se espera de mí es razonable</h5>
                        <div>
                            {[
                                { emoji: "😔", valor: "Totalmente en desacuerdo" },
                                { emoji: "🙁", valor: "Estoy en desacuerdo" },
                                { emoji: "😐", valor: "Ni de acuerdo o en desacuerdo" },
                                { emoji: "🙂", valor: "Estoy de acuerdo" },
                                { emoji: "😃", valor: "Totalmente de acuerdo" }
                            ].map((respuesta, index) => (
                                <label key={index} style={{ display: "inline-block", marginRight: "10px" }}>
                                    <div className="carita-btn">{respuesta.emoji}</div>
                                    <div>
                                        <input
                                            type="checkbox"
                                            className="checkbox-btn"
                                            value={respuesta.valor}
                                            onChange={() => handleCantidadTrabajo(respuesta.valor)}
                                            checked={cantidadTrabajo === respuesta.valor}
                                        />
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h5 className="h5-titulo">
                            Considero que cuento con las herramientas y los recursos adecuados (p. ej., equipos, componentes, suministros, hardware, software,
                            políticas, procedimientos etc.) para realizar mi trabajo adecuadamente.
                        </h5>
                        <div>
                            {[
                                { emoji: "😔", valor: "Totalmente en desacuerdo" },
                                { emoji: "🙁", valor: "Estoy en desacuerdo" },
                                { emoji: "😐", valor: "Ni de acuerdo o en desacuerdo" },
                                { emoji: "🙂", valor: "Estoy de acuerdo" },
                                { emoji: "😃", valor: "Totalmente de acuerdo" }
                            ].map((respuesta, index) => (
                                <label key={index} style={{ display: "inline-block", marginRight: "10px" }}>
                                    <div className="carita-btn">{respuesta.emoji}</div>
                                    <div>
                                        <input
                                            type="checkbox"
                                            className="checkbox-btn"
                                            value={respuesta.valor}
                                            onChange={() => handleHerramientasRecursos(respuesta.valor)}
                                            checked={herramientasRecursos === respuesta.valor}
                                        />
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                    <div>
                        <button className="enviar-btn" onClick={enviarRespuestas}>
                            Enviar Respuestas
                        </button>
                        <button className="modal-close-btn" onClick={toggleModal}>
                            Cerrar
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Encuesta;
